// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
import * as SessionAPI from "@/services/api/sessions";
import * as StudyAPI from "@/services/api/studies";
import { StudyInfo } from "@/psychlab/types";
import { useTranslate } from "@/plugins/translate";
import { FacebookWarning } from "@/components.run/facebook-warning";
import * as Platform from "@/platform";
// local
import LoadingScreen from "../vue/screens/loading.vue";
import LockedScreen from "../vue/screens/locked.vue";
import NotFoundScreen from "../vue/screens/not-found.vue";
import StartSession from "../vue/screens/start-session.vue";
import ResumeSession from "../vue/screens/resume-session.vue";

export const StartStudy = defineComponent({
	components:{
		LoadingScreen,
		LockedScreen,
		NotFoundScreen,
		StartSession,
		ResumeSession,
		FacebookWarning,
	},
	setup(props, context){

		const hasError = ref(false);
		const loading = ref(false);
		const notFound = ref(false);
		const info = ref<StudyInfo>();
		const started = ref(false);
		const existingSession = ref<string>();
		
		const { translate } = useTranslate(context);

		const isFacebook = computed(() => {
			//return true;
			return Platform.isFacebookApp();
		});

		const disabled = computed(() => info.value ? !info.value.enabled : false);

		const displayLanguage = computed(() => {
			if(!info.value){ return ""; }
			const lang = (info.value.language || context.root.$route.query["l"]) || "en";
			let l = info.value.language || "en";
			if(context.root.$route.query["l"]){
				l = context.root.$route.query["l"] as string;
			}
			return l;
		});

		const start = async() => {
			started.value = true;
			await instantiateProxy();
		};

		const resume = () => {
			started.value = true;
			if(!existingSession.value){ return; }
			openSession(existingSession.value);
		};

		const openSession = (sessionId:string) => {
			context.root.$router.push({
				name:"Run.Session",
				params:{
					sessionId
				},
				query:{ l:displayLanguage.value }
			});
		};

		const instantiateProxy = async() => {
			loading.value = true;
			const studyId = context.root.$route.params["proxyId"];
			try{
				const { token, session } = await StudyAPI.runStudy(studyId);
				SessionAPI.saveSessionToken(studyId, session, token);
				openSession(session);
			}
			catch({ response }){
				hasError.value = true;
			}
			loading.value = false;
		};

		const init = async() => {
			try {
				info.value = await StudyAPI.getStudyInfo(context.root.$route.params["proxyId"]);
				existingSession.value = SessionAPI.findActiveStudySession(context.root.$route.params["proxyId"]);
				context.root.$store.commit("localization/setPreferredLanguage", displayLanguage.value);
			}
			catch(err){
				notFound.value = true;
			}
		};

		const getPhrase = (key:string) => {
			return translate(key).toUpperCase();
		};

		init();

		return {
			hasError,
			loading,
			notFound,
			info,
			started,
			existingSession,
			disabled,
			displayLanguage,
			isFacebook,
			start,
			resume,
			getPhrase,
		};
	}
});
